import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import u from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: t = 16, useVw: c, useRem: l, color: o, withColor: n, removeClassName: a, disableSSR: m, style: i, ...p }) => {
  const f = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(u, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-jigoufuwu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), height: c ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), className: a ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: a ? "" : "24px-æºææå¡"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: a ? "" : "normal",
        fill: n ? r(o, 0, "#262933") : "#262933",
        datafollowfill: n ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M5.332 9.278a.8.8 0 0 1 .8-.8H9.28a.8.8 0 0 1 0 1.6H6.132a.8.8 0 0 1-.8-.8Zm.8 2.829a.8.8 0 1 0 0 1.6H9.28a.8.8 0 0 0 0-1.6H6.132Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.215 2.617c-1.25-.612-2.536-.674-3.55-.057-1.018.62-1.54 1.79-1.54 3.17v13.466c0 1.491 1.235 2.679 2.715 2.679h7.64l.031-.001h5.695c1.088 0 2.052-.25 2.734-.933.683-.682.933-1.647.933-2.734v-3.442c0-.046 0-.131-.01-.228-.04-1.007-.352-1.791-.918-2.362-.555-.56-1.27-.827-1.94-.974l-1.842-.408-1.019-.23a.8.8 0 0 0-.35 1.562l1.02.23 1.845.408h.001c.528.116.901.29 1.149.539.23.231.433.612.456 1.327a.82.82 0 0 0 .008.093v3.485c0 .872-.203 1.341-.464 1.603-.261.261-.73.464-1.603.464H13.28V7.836c0-.667-.243-1.337-.59-1.889-.348-.552-.848-1.06-1.446-1.352l-4.03-1.978ZM3.725 5.73c0-.997.363-1.555.772-1.804.413-.252 1.095-.323 2.014.126L10.54 6.03c.273.134.568.407.796.77.229.362.344.74.344 1.035v12.439H4.84c-.626 0-1.115-.501-1.115-1.079V5.731Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, h = x;
export {
  h as default
};
